import { render, staticRenderFns } from "./Nullify.vue?vue&type=template&id=273e0083"
import script from "./Nullify.vue?vue&type=script&lang=js"
export * from "./Nullify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports